var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "navigation__sub-menu",
      class: { active: _vm.active, hover: _vm.itemHovered }
    },
    [
      _c("div", [
        _c(
          "div",
          {
            on: {
              mouseover: _vm.handleMouseOver,
              mouseleave: _vm.handleMouseLeave,
              click: function($event) {
                !_vm.active && _vm.handleMouseLeave
              }
            }
          },
          [_vm._t("main")],
          2
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.active,
                expression: "active"
              }
            ],
            staticClass: "navigation__sub-menu__items"
          },
          [_vm._t("expanded")],
          2
        )
      ]),
      _c(
        "q-popover",
        {
          ref: "popover",
          staticClass: "navigation__sub-menu__popover",
          attrs: { anchor: "top right", disable: _vm.active }
        },
        [
          _c(
            "div",
            {
              on: {
                mouseover: _vm.handleMouseOver,
                mouseleave: _vm.handleMouseLeave
              }
            },
            [
              _c(
                "q-list",
                { attrs: { "no-border": "", link: "" } },
                [_vm._t("popover")],
                2
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }